<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <form @submit.prevent="submit">
          <card class="stacked-form">
            <fg-input label="Name"
              type="text"
              v-model="product.name"
              :error="valErrors['name'] ? valErrors['name'][0] : null"
            />
            <fg-input label="Kurzbezeichnung"
              type="text"
              v-model="product.short_name"
              :error="valErrors['short_name'] ? valErrors['short_name'][0] : null"
              icon="fa-question-circle" icon-tooltip="In bestimmten Fällen kann es Sinn machen nur eine Abkürzung des Produkts anzuzeigen, geben Sie hier also falls erforderlich eine Abkürzung für das Produkt ein"
            />
            <l-checkbox
              v-model="product.has_variations"
              v-if="!product.is_variation_of"
              :disabled="! canChangeHasVariations"
              v-tooltip.top-start="tooltipChangeHasVariations"
            >Produkt hat Variationen</l-checkbox>
            <div class="form-group has-label">
              <label>Warengruppen</label>
              <multiselect v-model="product.product_categories"
                :options="productCategories"
                track-by="id"
                label="name"
                :multiple="true"
              />
            </div>
            <div class="row">
              <div class="col-sm-8">
                <fg-input label="Verkaufspreis (brutto)"
                  type="text"
                  :value="price"
                  @input="price = $event"
                  :error="valErrors['price'] ? valErrors['price'][0] : null"
                />
              </div>
              <div class="col-sm-4">
                <div class="form-group has-label">
                  <label>Steuersatz</label>
                  <multiselect v-model="product.tax"
                    :options="taxOptions.map(taxOption => taxOption.value)"
                    :custom-label="taxOption => taxOptions.find(x => x.value == taxOption).label"
                    :allow-empty="false"
                    selectLabel=""
                    deselectLabel=""
                  />
                </div>
              </div>
            </div>
            <price-input :price="product.standard_price"
              label="Standard Einkaufspreis (netto)"
              @input="product.standard_price = $event"
            />
            <div class="has-error" v-if="valErrors['standard_price']" style="margin-top: -12px; margin-bottom: 12px;">
              <div class="text-danger invalid-feedback" style="display: block;">
                {{ valErrors['standard_price'][0] }}
              </div>
            </div>
            <fg-input label="Warnschwelle"
              type="number"
              v-model="product.warnschwelle"
              :error="valErrors['warnschwelle'] ? valErrors['warnschwelle'][0] : null"
              icon="fa-question-circle" icon-tooltip="Wird dieser Wert unterschritten wird eine Warnung angezeigt, dass das Produkt nachbestellt werden muss"
            />
            <fg-input label="Lager Sollmenge"
              type="number"
              v-model="product.lager_soll_menge"
              :error="valErrors['lager_soll_menge'] ? valErrors['lager_soll_menge'][0] : null"
              icon="fa-question-circle" icon-tooltip="Hier können Sie den Ziellagerstand den Sie im Lager anstreben angeben, dies ist hilfreich um z.B. bei Neubestellung wenn die Warnschwelle erreicht ist zu wissen, wieviel Produkte bestellt werden sollen"
            />
            <fg-input label="Artikelnummer"
              type="text"
              v-model="product.number"
              :error="valErrors['number'] ? valErrors['number'][0] : null"
              icon="fa-question-circle" icon-tooltip="Unsere Artikelnummer für das Produkt"
            />
            <!--
            <div class="form-group has-label" :class="valErrors['barcode'] ? 'has-error' : ''">
              <label>Barcode</label>
              <div class="input-group">
                <input aria-describedby="addon-right addon-left" type="text" class="form-control"
                  v-model="product.barcode"
                >
                <div class="input-group-append">
                  <button class="btn btn-fill btn-secondary" type="button" style="margin-bottom: 0"
                    @click="generateBarcode('barcode')"
                  >
                  <i class="fas fa-sync-alt"></i>
                  </button>
                </div>
              </div>
              <div class="text-danger invalid-feedback" style="display: block;"
                v-if="valErrors['barcode']"
              >
                {{ valErrors['barcode'][0] }}
              </div>
            </div>
            -->
            <fg-input label="Referenznummer"
              type="text"
              v-model="product.referenznummer"
              :error="valErrors['referenznummer'] ? valErrors['referenznummer'][0] : null"
              icon="fa-question-circle" icon-tooltip="Artikelnummer des Herstellers des Produkts = Nicht unsere eigenen Produkte"
            />
            <fg-input label="Warentarifnummer"
              type="text"
              v-model="product.customs_number"
              :error="valErrors['customs_number'] ? valErrors['customs_number'][0] : null"
              icon="fa-question-circle" icon-tooltip="Für den Zoll"
            />
            <l-checkbox v-model="product.is_for_webshop">Ist Webshop Produkt</l-checkbox>
            <div class="d-flex justify-content-between">
              <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
              <button type="button" v-if="isCreateForm"
                @click.prevent="$emit('submitAndNew', product)" class="btn btn-fill btn-info"
              >Erstellen und weiteres Produkt anlegen</button>
            </div>
          </card>
        </form>
      </div>
      <div class="col-sm-6">
        <card class="stacked-form">
          <label>Kategorien & Eigenschaften</label>
          <div v-for="customCategory in customCategories" :key="customCategory.id">
            <div class="form-group has-label">
              <label><strong>{{ customCategory.name }}</strong></label>
              <multiselect v-model="product.product_features[customCategory.id].feature"
                @input="selectFeature($event, customCategory)"
                :options="customCategory.features"
                track-by="id"
                label="name"
                :disabled="Boolean(product.is_variation_of)"
              />
            </div>
            <div class="form-group has-label" v-if="product.product_features[customCategory.id].feature">
              <label>{{ product.product_features[customCategory.id].feature.name }}</label>
              <template v-if="product.product_features[customCategory.id].feature.type === 'dropdown'">
                <template v-if="product.product_features[customCategory.id].feature.multiple">
                  <multiselect v-model="product.product_features[customCategory.id].feature_options"
                    :options="product.product_features[customCategory.id].feature.options"
                    track-by="id"
                    label="value"
                    :multiple="true"
                  />
                </template>
                <template v-else>
                  <multiselect v-model="product.product_features[customCategory.id].feature_option"
                    :options="product.product_features[customCategory.id].feature.options"
                    track-by="id"
                    label="value"
                    @input="product.product_features[customCategory.id].feature_option_id = $event ? $event.id : null"
                  />
                </template>
              </template>
              <template v-if="product.product_features[customCategory.id].feature.type === 'textinput' || product.product_features[customCategory.id].feature.type === 'number'">
                <input class="form-control" v-model="product.product_features[customCategory.id].feature_option_value"
                  :type="product.product_features[customCategory.id].feature.type === 'textinput' ? 'text' : 'number'"
                  step=".5"
                >
              </template>
              <template v-if="product.product_features[customCategory.id].feature.type === 'textarea'">
                <textarea class="form-control" v-model="product.product_features[customCategory.id].feature_option_value"></textarea>
              </template>
              <template v-if="product.product_features[customCategory.id].feature.type === 'checkbox'">
                <el-checkbox-group v-model="product.product_features[customCategory.id].feature_option">
                  <el-checkbox
                    v-for="bla in product.product_features[customCategory.id].feature.options"
                    :key="bla.id"
                    :label="bla.value"
                  />
                </el-checkbox-group>
              </template>
              <template v-if="product.product_features[customCategory.id].feature.type === 'date'">
                <el-date-picker
                  v-model="product.product_features[customCategory.id].feature_option_value"
                  format="dd.MM.yyyy"
                  value-format="yyyy-MM-dd"
                  :clearable="false"
                  :picker-options="{ firstDayOfWeek: 1 }"
                />
              </template>
              <div class="text-danger invalid-feedback" style="display: block;"
                v-if="showRequiredFeatureError &&
                  product.product_features[customCategory.id].feature.is_required &&
                  featureHasNovValue(product.product_features[customCategory.id])
                "
              >
                Eigenschaft muss ausgefüllt werden.
              </div>
              <div v-if="isCreateForm && product.product_features[customCategory.id].feature.create_variations">
                <l-checkbox
                  v-model="product.product_features[customCategory.id].create_variations"
                  :disabled="! product.has_variations"
                  v-tooltip.top-start="product.has_variations ? false : 'Nicht möglich für Produkte ohne Variationen'"
                >
                  Für alle Eigenschaften automatisch Variationen erstellen
                </l-checkbox>
              </div>
            </div>
          </div>
        </card>
        <info-highlights-card v-if="isCreateForm"
          :comments="product.info_highlights"
          @addComment="$emit('addComment', $event)"
          @deleteComment="$emit('deleteComment', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import priceWatcher from './price-watcher'
import PriceInput from 'src/components/price-input'
import api from 'src/api'
import { CheckboxGroup, Checkbox, DatePicker } from 'element-ui'
import InfoHighlightsCard from 'src/components/info-highlights-card'

export default {
  props: ['valErrors', 'initProduct', 'submitText', 'uploading', 'customCategories'],
  components: {
    PriceInput,
    InfoHighlightsCard,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [DatePicker.name]: DatePicker
  },
  mixins: [priceWatcher],
  data () {
    return {
      api,
      product: this.initProduct,
      productCategories: [],
      storeViews: [],
      taxOptions: [
        { label: 'Standard (20%)', value: 0.2 },
        { label: 'Reduziert (10%)', value: 0.1 },
        { label: '0%', value: 0.0 }
      ],
      showRequiredFeatureError: false
    }
  },
  methods: {
    submit () {
      this.showRequiredFeatureError = false

      let hasRequired = false

      Object.values(this.product.product_features).filter(({ feature }) => feature).forEach(feature => {
        if (feature.feature.is_required && !hasRequired) {
          hasRequired = this.featureHasNovValue(feature)
        }
      })

      if (this.product.has_variations || !hasRequired) {
        this.$emit('submit', this.product)
      } else {
        this.showRequiredFeatureError = true
      }
    },
    getPrice () {
      return this.product.price
    },
    setPrice (price) {
      this.product.price = price
    },
    async generateBarcode (barcode) {
      const { data } = await this.$http.get('/barcode/generate')
      this.product[barcode] = data
    },
    selectFeature (feature, customCategory) {
      if (feature) {
        this.product.product_features[customCategory.id].feature_id = feature.id
        this.product.product_features[customCategory.id].create_variations = feature.create_variations
      } else {
        this.product.product_features[customCategory.id].feature_id = null
      }
      this.product.product_features[customCategory.id].feature_option = null
      this.product.product_features[customCategory.id].feature_options = null
    },
    featureHasNovValue (feature) {
      if (feature.feature.type === 'dropdown') {
        if (feature.feature.multiple) {
          return feature.feature_options ? feature.feature_options.length === 0 : true
        } else {
          return !feature.feature_option_id
        }
      } else {
        return !feature.feature_option_value
      }
    }
  },
  computed: {
    isCreateForm () {
      return this.submitText === 'Erstellen'
    },
    canChangeHasVariations () {
      if (this.isCreateForm) return true

      if (this.product.has_variations) {
        return this.product.variations.length === 0
      }
      return this.product.instances.length === 0
    },
    tooltipChangeHasVariations () {
      if (this.canChangeHasVariations) return false

      if (this.product.has_variations) {
        return 'Änderung nicht möglich, da bereits Variationen dieses Produkts existieren'
      }
      return 'Änderung nicht möglich, da bereits Instanzen dieses Produkts existieren'
    }
  },
  created () {
    this.$http.get(`/product_categories`).then(({ data }) => {
      this.productCategories = data
    })
  }
}
</script>

<style lang="scss">
  .dropbox {
    margin-top: .75rem;
    outline: 2px dashed grey;
    outline-offset: -10px;
    background: #ffa33340;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;

    &:hover {
      background: #ffa33380;
    }

    input {
      opacity: 0; /* invisible but it's there! */
      width: 100%;
      height: 200px;
      position: absolute;
      cursor: pointer;
    }

    p {
      font-size: 1.2em;
      text-align: center;
      padding: 50px 0;
    }
  }
  .box-card  {
    margin-bottom: 8px;
    .card-header {
      padding: 15px;
      border-bottom: 1px solid #ebeef5 !important;
      box-sizing: border-box;
    }
  }
</style>
